import qs from "qs";
import { useCallback, useState } from "react";
import { HotelsSearchCriteria } from "../types/HotelsSearchCriteria";
import { CommunicationType } from "../enums/CommunicationType";
import { useAppAttributes } from "./useAppAttributes";

export function useHotelsSearchCriteria(isInitialTab: boolean) {
  const appAttributes = useAppAttributes();
  // Params
  const getHotelsSearchCriteriaParams = useCallback((): HotelsSearchCriteria => {
    const locationParams = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    });
    const searchCriteria = new HotelsSearchCriteria(locationParams as { [key: string]: string });
    return searchCriteria;
  }, []);

  // State
  const [searchCriteria, setSearchCriteria] = useState(
    isInitialTab && appAttributes.communicationType === CommunicationType.Standalone
      ? getHotelsSearchCriteriaParams()
      : undefined
  );
  const [previousSearchCriteria, setPreviousSearchCriteria] = useState<HotelsSearchCriteria>();

  const changeSearchCriteria = useCallback((searchCriteria: HotelsSearchCriteria) => {
    setSearchCriteria((currentSearchCriteria) => {
      setPreviousSearchCriteria(currentSearchCriteria);
      return searchCriteria;
    });
  }, []);

  return { previousSearchCriteria, searchCriteria, setSearchCriteria: changeSearchCriteria };
}
